export default __webpack_public_path__ + "static/media/btn_arrow_down.4398ce30.svg";